import { useCallback } from "react";
import { RegionInfoFilter } from "../../models/region";
import { useGetList, useStore } from "react-admin";
import { Cell, Legend, ResponsiveContainer, Tooltip } from 'recharts'
import { Pie, PieChart } from "recharts";
import { useColorScheme } from "../../hooks/use-color-scheme";
import { colorByColorScheme } from "../../models/color";


type RegionSchools = {
  id: number;
  schoolType: string;
  schoolRating: number;
  dataCount: number;
}

const RADIAN = Math.PI / 180;


export const RegionSchoolsChart = ({ filter }: { filter: RegionInfoFilter }) => {

  // Colors workaround
  const colorScheme = useColorScheme();
  const [colorSchemeReverse] = useStore('map.imageColorSchemeReverse', false);

  const getColor = useCallback((value: number) => {
    return colorByColorScheme(0, 10.0, value, colorScheme?.colors, colorSchemeReverse);
  }, [colorScheme, colorSchemeReverse]);

  const { data: schoolsData, isLoading: isLoadingSchools } = useGetList<RegionSchools>('region/schools', { filter });

  const highSchoolData = schoolsData?.filter(school => school.schoolType === 'high');
  const middleSchoolData = schoolsData?.filter(school => school.schoolType === 'middle');
  const elementarySchoolData = schoolsData?.filter(school => school.schoolType === 'elementary');

  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, payload }: any) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
    const y = cy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);
    const data = payload as RegionSchools;

    return (
      <text x={x} y={y} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
        {data.schoolRating}
      </text>
    );
  };

  const renderLabel = ({ payload }: any) => {
    return payload.schoolRating;
  };

  const renderPie = (
    data: RegionSchools[] | undefined, 
    innerRadius: string,
    outerRadius: string
  ) => {
    return (      
        <Pie
          //isAnimationActive={false}
          data={data}
          dataKey="dataCount"
          cx="50%"
          cy="50%"
          startAngle={180}
          endAngle={0}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          paddingAngle={5}
          labelLine={false}
          label={renderCustomizedLabel}
        >
          {data?.map((entry) => (
            <Cell key={`cell-${entry.id}`} fill={getColor(entry.schoolRating)} />
          ))}
          <Tooltip />
        </Pie>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart width={400}>
        {renderPie(highSchoolData, "80%", "100%")}
        {renderPie(middleSchoolData, "50%", "70%")}
        {renderPie(elementarySchoolData, "20%", "40%")}
      </PieChart>
    </ResponsiveContainer>
  )
};

